import React from 'react';

import { Helmet } from 'react-helmet';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';

import NotesList  from 'src/component/UI/NotesList';
import { fetchNotes } from 'src/module/note/action';
import UnitSelector from 'src/component/UI/UnitSelector';

import { getNuisanceNotes, getLoadingNuisanceNotes, getNumNotesNuisancePages, getTotalNuisanceNotes } from 'src/module/note/selector';
import { isWhitelabel } from 'src/utils/utils';

export default function NuisanceScreen () {
  const selectors = {
    getNotes: getNuisanceNotes,
    getLoadingNotes: getLoadingNuisanceNotes,
    getNumNotesPages: getNumNotesNuisancePages,
    getTotalNotes: getTotalNuisanceNotes
  };

  const title = isWhitelabel() ? 'ATCOM' : 'SmartTrace';

  return (
    <div className='page' id='nuisance-screen'>
      <Helmet>
        <title>{title} - Nuisance</title>
      </Helmet>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <Paper>
            <UnitSelector/>
          </Paper>
        </Grid>
      </Grid>
      <br />
      <Paper>
        <NotesList
          noteType={'nuisance'}
          selectors={selectors}
          showSubject
          showExpiry
          showAddNoteButton
          showSearchBar
          showArchivedOption
          showDeleteIcon
          fetch={fetchNotes}
        />
      </Paper>
    </div>
  );
}
